export const DEFAULT_ICON_SIZE = 17;
